import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import {
    getInternships as onGetInternships,
    addNewInternship as onAddNewInternship,
    updateInternship as onUpdateInternship,
    deleteInternship as onDeleteInternship,

    getInternshipStructures as onGetInternshipStructures,
    getStudents as onGetStudents,
    getTeachers as onGetTeachers,
} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const Intership = () => {

    //meta title
    document.title = "Soutenances | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [intership, setIntership] = useState(null);
    


 

    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            uid: (intership && intership.uid) || '',
            student_id: (intership && intership.student_id) || '',
            structure_id: (intership && intership.structure_id) || '',
            teacher_id: (intership && intership.teacher_id) || '',
            duration: (intership && intership.duration) || '',
            rapport_url: (intership && intership.rapport_url) || '',
            status: (intership && intership.status) || '',
            
        },
        validationSchema: Yup.object({
           
            student_id: Yup.number().required("Veuillez sélectionner l'étudiant"),
            structure_id: Yup.number().required("Veuillez sélectionner la structure"),
            teacher_id: Yup.number().required("Veuillez sélectionner le professeur"),
            duration: Yup.number().required("Veuillez saisir la durée"),
            rapport_url: Yup.string().required("Veuillez saisir l'url du rapport'"),
            status: Yup.string().required("Veuillez sélectionner le statut'"),
            
  
        }),
        onSubmit: (values) => {
            if (isEdit) {
                //const payload = { series_category: values }
                const intership = {
                    //id: values.id,
                    uid: values.uid,
                    student_id: values.student_id,
                    structure_id: values.structure_id,
                    teacher_id: values.teacher_id,
                    duration: values.duration,
                    rapport_url: values.rapport_url,
                    status: values.status,
                    
                };
           
                dispatch(onUpdateInternship(intership));
                validation.resetForm();
            } else {
                const newIntership = {
                    //id: values["id"],
                    //uid: values["uid"],
                   
                    student_id: values["student_id"],
                    structure_id: values["structure_id"],
                    teacher_id: values["teacher_id"],
                    duration: values["duration"],
                    rapport_url: values["rapport_url"],
                    status: values["status"],
                   
                };
        
                dispatch(onAddNewInternship(newIntership));
                validation.resetForm();
            }
            toggle();
        },
    });

    const dispatch = useDispatch();

    const IntershipProperties = createSelector(
        (state) => state.intershipReducer, 
        (intershipReducer) => ({
            interships: intershipReducer.interships,
            loading: intershipReducer.loading
        })
    );

    const {interships, loading} = useSelector(IntershipProperties);

    const [isLoading, setLoading] = useState(loading)


   

     // Students
    const StudentProperties = createSelector(
        (state) => state.studentReducer, 
        (studentReducer) => ({
            students: studentReducer.students,
            loading: studentReducer.loading
        })
    );

    const {students} = useSelector(StudentProperties);

      // Structures
    const StructureProperties = createSelector(
        (state) => state.structureReducer, 
        (structureReducer) => ({
            structures: structureReducer.structures,
            loading: structureReducer.loading
        })
    );

    const {structures} = useSelector(StructureProperties);



    // Teachers
    const TeacherProperties = createSelector(
        (state) => state.teacherReducer, 
        (teacherReducer) => ({
            teachers: teacherReducer.teachers,
            loading: teacherReducer.loading
        })
    );

    const {teachers} = useSelector(TeacherProperties);
    

    

    useEffect(() => {
        if (interships && !interships.length) {
            dispatch(onGetInternships());
        }

        if (structures && !structures.length) {
            dispatch(onGetInternshipStructures());
        }

        if (students && !students.length) {
            dispatch(onGetStudents());
        }

         if (teachers && !teachers.length) {
            dispatch(onGetTeachers());
        }
    }, [dispatch, interships.length, structures.length, students.length, teachers.length]);



   


    

  

    const toggle = () => {
        if (modal) {
            setModal(false);
            setIntership(null);
        } else {
            setModal(true);
        }
    };

    const handleIntershipClick = arg => {
        const intership = arg;
        setIntership({
            id: intership.id,
            uid: intership.uid,
            student_id: intership.student_id,
            structure_id: intership.structure_id,
            teacher_id: intership.teacher_id,
            duration: intership.duration,
            rapport_url: intership.rapport_url,
            status: intership.status,
           
        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (intership) => {
        setIntership(intership);
        setDeleteModal(true);
    };

    const handleDeleteInternship = () => {
        if (intership && intership.id) {
            dispatch(onDeleteInternship(intership));
            setDeleteModal(false);
        }
    };

    const onClickNewDefense = () => {
        setIsEdit(false);
        setIntership(null);
        toggle();
        //setModal(true)
    };

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Date",
                accessorKey: "defense_date",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Étudiant",
                accessorKey: "student.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Structure",
                accessorKey: "structure.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Module",
                accessorKey: "subject_title",
                enableColumnFilter: false,
                enableSorting: true,
            },

             {
                header: "Résultat",
                accessorKey: "result",
                enableColumnFilter: false,
                enableSorting: true,
            },

          
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleIntershipClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteInternship}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Soutenance" breadcrumbItem="Liste des soutenances" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                    <Link to="#!" onClick={onClickNewDefense} className="btn btn-primary me-1">Ajouter une soutenance</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={interships || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    <Modal 
                        isOpen={modal} 
                        toggle={toggle}
                         backdrop={'static'}
                            id="staticBackdrop"
                    >
                        <ModalHeader toggle={toggle} tag="h4">
                            {!!isEdit ? "Modifier - Soutenance" : "Ajouter - Soutenance"}
                        </ModalHeader>
                        <ModalBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col className="col-12">

                                    <div className="mb-3">
                                        <Label>Date</Label>
                                        <Input
                                            name="defense_date"
                                            type="date"
                                            placeholder="Date"
                                            validate={{
                                                required: { value: true },
                                            }}
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.defense_date || ""}
                                            invalid={
                                                validation.touched.defense_date && validation.errors.defense_date ? true : false
                                            }
                                        />
                                        {validation.touched.defense_date && validation.errors.duration ? (
                                            <FormFeedback type="invalid">{validation.errors.defense_date}</FormFeedback>
                                        ) : null}
                                    </div>
                                       

                                       

                                        <div className="mb-3">
                                            <Label>Structure</Label>
                                            <Input
                                                name="structure_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.structure_id || ""
                                                }
                                                invalid={
                                                    validation.touched.structure_id && validation.errors.structure_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {structures.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.structure_id && validation.errors.structure_id ? (
                                                <FormFeedback type="invalid">{validation.errors.structure_id}</FormFeedback>
                                            ) : null}
                                        </div>


                                        <div className="mb-3">
                                            <Label>Étudiant</Label>
                                            <Input
                                                name="student_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.student_id || ""
                                                }
                                                invalid={
                                                    validation.touched.student_id && validation.errors.student_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {students.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.student_id && validation.errors.student_id ? (
                                                <FormFeedback type="invalid">{validation.errors.student_id}</FormFeedback>
                                            ) : null}
                                        </div>

                                       

                                        

                                         <div className="mb-3">
                                            <Label>Module</Label>
                                            <Input
                                                name="subject_title"
                                                type="text"
                                                placeholder="Module"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.subject_title || ""}
                                                invalid={
                                                    validation.touched.subject_title && validation.errors.subject_title ? true : false
                                                }
                                            />
                                            {validation.touched.subject_title && validation.errors.subject_title ? (
                                                <FormFeedback type="invalid">{validation.errors.subject_title}</FormFeedback>
                                            ) : null}
                                        </div>

                                         <div className="mb-3">
                                            <Label>Résultat</Label>
                                            <Input
                                                name="result"
                                                type="text"
                                                placeholder="Résultat"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.result || ""}
                                                invalid={
                                                    validation.touched.result && validation.errors.result ? true : false
                                                }
                                            />
                                            {validation.touched.result && validation.errors.result ? (
                                                <FormFeedback type="invalid">{validation.errors.result}</FormFeedback>
                                            ) : null}
                                        </div>
                                       
                                       
                                        
                                       

                                        

                                        
                                        
                                        
                                        
                                        
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="text-end">
                                            <Button color="btn btn-primary me-1"
                                                type="submit"
                                                className="save-user"
                                            >
                                                
                                                {!!isEdit ? "Modifier " : "Enregistrer"}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}


export default Intership;